import { Component, Input, OnInit, Output } from '@angular/core';
import { TransparencyService } from '../../utils/transparency.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss'
})
export class AboutUsComponent implements OnInit {
  
  constructor(private transparencyService: TransparencyService) { }

  ngOnInit(): void {
    this.transparencyService.setTransparency(false);
  }
}
